<template>
  <div>
    <div>
      <LinkEntity :payload="payload" :additional_data="{ resource_type: 'Applicant' }" />
    </div>
    <br />
    <div>
      <GhanaFlag :payload="payload" />
    </div>
    <br />
    <div>
      <AttributeDisplay
        :value="payload.salary_expectations_comment"
        :data="payload"
        title="Salary Expectations"
        requestName="updateApplicant"
        requestValue="salary_expectations_comment"
        classTitle="py-0 mt-5 ltr has-text-right"
        classValue="py-0 m-0"
        horizantal
      />
    </div>
  </div>
</template>
<script>
import LinkEntity from '@/components/LinkEntity'
import AttributeDisplay from '@/components/AttributeDisplay'
import GhanaFlag from '@/components/GhanaFlag'

export default {
  name: 'TableCellFullName',
  components: {
    AttributeDisplay,
    LinkEntity,
    GhanaFlag
  },
  props: {
    payload: {
      type: Object
    }
  }
}
</script>
